const state = {
  adminsList: [],
  dodAdminNotifications: [],
};
const mutations = {
  SET_DOD_ADMINS_LIST(state, admins) {
    state.adminsList = admins;
  },
  SET_DOD_ADMIN_NOTIFICATIONS(state, notifications) {
    state.dodAdminNotifications = notifications;
  },
};
const getters = {
  getDodAdminsList: (state) => state.adminsList,
  getDodAdminNotifications: (state) => state.dodAdminNotifications,
};

export default {
  state,
  mutations,
  getters,
};
